(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cfb-consent-map"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cfb-consent-map')) {
  customElements.define('cfb-consent-map', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.notice = this.querySelector('.cfb-map-consent__notice');
      this.frame = this.querySelector('.cfb-map-consent__frame');
      this.enableButton = this.querySelector('.cfb-map-consent__enable');
      this.disableButton = this.querySelector('.cfb-map-consent__disable');
      this.status = this.querySelector('.cfb-map-consent__status');
      this.enableButton.hidden = false;
      this.enableButton.addEventListener('click', () => this.enable());
      this.disableButton.addEventListener('click', () => this.disable(true));
      this.onConsent = (event) => {
        const consent = event.detail || {};
        if (consent.marketingAllowed === false || consent.preferencesAllowed === false || consent.analyticsAllowed === false) this.disable(false);
      };
      document.addEventListener('visitorConsentCollected', this.onConsent);
    }
    disconnectedCallback() {
      document.removeEventListener('visitorConsentCollected', this.onConsent);
      this.initialized = false;
    }
    enable() {
      if (this.frame.childElementCount) return;
      const iframe = document.createElement('iframe');
      iframe.src = this.dataset.embedUrl;
      iframe.title = this.dataset.mapTitle;
      iframe.width = '640';
      iframe.height = '440';
      iframe.referrerPolicy = 'no-referrer';
      iframe.allowFullscreen = true;
      this.frame.replaceChildren(iframe);
      this.frame.hidden = false;
      this.notice.hidden = true;
      this.disableButton.hidden = false;
      this.status.textContent = this.dataset.activeMessage;
      this.disableButton.focus();
    }
    disable(moveFocus) {
      if (!this.frame.childElementCount) return;
      this.frame.replaceChildren();
      this.frame.hidden = true;
      this.notice.hidden = false;
      this.disableButton.hidden = true;
      this.status.textContent = this.dataset.disabledMessage;
      if (moveFocus) this.enableButton.focus();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cfb-cookie-preferences"] && !Shopify.designMode) return;
  try {
    (() => {
  function setupPrivacyLinks() {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    document.querySelectorAll('.cfb-cookie-preferences').forEach((container) => {
      container.hidden = false;
      const button = container.querySelector('button');
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', async () => {
        const error = container.querySelector('[role="status"]');
        error.hidden = true;
        button.disabled = true;
        try { await window.privacyBanner.showPreferences(); }
        catch { error.hidden = false; }
        finally { button.disabled = false; }
      });
    });
  }
  setupPrivacyLinks();
  window.addEventListener('load', setupPrivacyLinks);
  document.addEventListener('DOMContentLoaded', setupPrivacyLinks);
  document.addEventListener('shopify:section:load', setupPrivacyLinks);
  document.addEventListener('visitorConsentCollected', setupPrivacyLinks);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cfb-product-finder"] && !Shopify.designMode) return;
  try {
    function cfbFinderVariant(variants) {
  return variants.find((variant) => variant.available && Number.isFinite(variant.price)) || null;
}
function cfbFinderNormalize(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
}
function cfbFinderMatches(item, family, query) {
  if (family !== 'all' && item.family !== family) return null;
  if (!cfbFinderNormalize(item.title).includes(cfbFinderNormalize(query).trim())) return null;
  return cfbFinderVariant(item.variants);
}
if (!customElements.get('cfb-product-finder')) {
  customElements.define('cfb-product-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.search = this.querySelector('[data-finder-search]');
      this.results = this.querySelector('.cfb-finder__results');
      this.status = this.querySelector('[data-finder-status]');
      this.cards = Array.from(this.querySelectorAll('[data-finder-card]')).map((element) => ({
        element,
        family: element.dataset.family,
        title: element.dataset.title,
        select: element.querySelector('[data-finder-format]'),
        variants: Array.from(element.querySelectorAll('option')).map((option) => ({option, id: option.value, available: option.dataset.available === 'true', price: Number(option.dataset.price), money: option.dataset.money, format: option.dataset.format, unit: option.dataset.unit, url: option.dataset.url}))
      }));
      this.querySelector('.cfb-finder__controls').hidden = false;
      this.querySelector('.cfb-finder__bottom').hidden = false;
      this.results.hidden = false;
      this.querySelectorAll('input[type="radio"]').forEach((radio) => radio.addEventListener('change', () => this.update(true), {signal}));
      this.search.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.update(true), 120);
      }, {signal});
      this.querySelectorAll('[data-finder-reset]').forEach((button) => button.addEventListener('click', () => {
        this.search.value = '';
        const all = this.querySelector('input[type="radio"][value="all"]');
        all.checked = true;
        this.update(true);
        all.focus();
      }, {signal}));
      this.cards.forEach((item) => item.select.addEventListener('change', () => {
        const variant = item.variants.find((value) => value.id === item.select.value);
        if (variant && !variant.option.disabled) {
          this.paint(item, variant);
          this.status.textContent = item.title + ' · ' + variant.format + ' · ' + variant.money;
        }
      }, {signal}));
      this.update(true);
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.searchTimer);
      this.initialized = false;
    }
    paint(item, variant) {
      item.element.querySelector('[data-finder-price]').textContent = variant.money;
      item.element.querySelector('[data-finder-unit]').textContent = variant.unit;
      item.element.querySelectorAll('[data-finder-link]').forEach((link) => {link.href = variant.url;});
    }
    update(reset) {
      const family = this.querySelector('input[type="radio"]:checked')?.value || 'all';
      this.matches = [];
      this.cards.forEach((item) => {
        const variant = cfbFinderMatches(item, family, this.search.value);
        item.element.hidden = true;
        item.variants.forEach((value) => {
          value.option.disabled = !value.available;
          value.option.hidden = value.option.disabled;
        });
        if (variant) this.matches.push({item, variant});
      });
      this.matches.sort((a, b) => a.item.title.localeCompare(b.item.title));
      this.matches.forEach(({item, variant}) => {
        if (reset || item.select.selectedOptions[0]?.disabled) item.select.value = variant.id;
        const selected = item.variants.find((value) => value.id === item.select.value && !value.option.disabled) || variant;
        item.select.value = selected.id;
        this.paint(item, selected);
        item.element.hidden = false;
        this.results.append(item.element);
      });
      this.querySelector('.cfb-finder__empty').hidden = this.matches.length > 0;
      this.status.textContent = this.dataset.resultsLabel.replace('{total}', String(this.matches.length));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
